import React, { forwardRef } from 'react';

const Input = forwardRef(({ onChange, ...attrs }, ref) => {
  return <input {...attrs} ref={ref} onChange={onChange} />;
});

export default Input;



// WEBPACK FOOTER //
// ./app/javascript/common/components/Input/Input.js